import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function AgenteIA() {
  const solucion = getSolucion("agente-ia")!;
  return <SolucionPage solucion={solucion} />;
}
